<template>
    <div class="rp-messenger-header__conversation" :style="conversationHeaderStyle">
		<el-badge class="count-badge" :hidden="notificationCount<=0" :value="notificationCount">
			<BackButton @click="$emit('onBackButtonClick')" />
		</el-badge>
		<template 
			v-if="(headerForScenarios) || (chatingAssignee === undefined || chatingAssignee.type === undefined)"
			>
			<div class="rp-conversation-header-warpper">
			<div class="rp-conversation-header-agent animated fast fadeInRight"  v-if="(chatingAssignee === undefined || chatingAssignee.type === undefined) && openHeader === false">
				<div class="agent" :key="index" v-for="(agent,index) in selectedAgent">
					<ImageContainer :title="agent.firstName" :imgSrc="agent.imageURL || ''" height="32" width="32" :initial='initial(agent)'/>
					<!-- <div v-if="isAgentOnline(agent)" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info status-for-team"></div> -->
				</div>
				<div class="intro-about-company">
					<div class="company-name animated fast fadeInRight" :title="brandName">
						{{ brandName }}
					</div>
					<div class="company-welcome-text" :title="getIntro">
						{{ getIntro }}
					</div>
				</div>
			</div>

			<!-- Added to fix missing header when , someone creates a chat using Scenario and get back and click Get Help -->

			<div class="rp-agent-header-full animated fadeInRight" v-if="chatingAssignee.type === 'assignee' && openHeader === true">
				<div class="agent-details-profile">
					<div class="agent-img" >
						<div class="agent-image">
							<ImageContainer :imgSrc="chatingAssignee.imageURL || ''" height="50" width="50" :initial='initial(chatingAssignee)'/>
						</div>
					</div>
					<div>
						{{ chatingAssignee.firstName }}
					</div>
				</div>
			</div>
			<div class="rp-agent-header animated fadeInRight" v-else-if="chatingAssignee.type === 'assignee'">
				<div class="agent-img" >
					<div class="agent-image">
						<ImageContainer :title="chatingAssignee.firstName" :imgSrc="chatingAssignee.imageURL || ''" height="40" width="40" :initial='initial(chatingAssignee)'/>
						<!-- <div v-if="isAgentOnline(chatingAssignee)" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info status-for-assignee"></div> -->
					</div>
				</div>
				<div class="intro-about-company">
					<div class="company-name">{{ chatingAssignee.firstName }}</div>
					<div class="company-welcome-text animated fast fadeInRight" >
						{{ getIntro }}
						<!-- {{ isAgentOnline(chatingAssignee) ? 'Online' : nextAvailableBusinessHours }} -->
					</div>
				</div>
			</div>

			<!--[Fix Ends]: Added to fix missing header when , someone creates a chat using Scenario and get back and click Get Help -->
			<CloseChatUI
				:closingChat="closingChat"
				v-if="canDisplayCloseChat"
				@closeChat="closeChat"
			/>
			</div>
		</template>
		<template v-else>
			<div class="rp-conversation-header-warpper">
			<div class="rp-agent-header-full-team animated fadeInRight" v-if="chatingAssignee.type === 'team' && openHeader === true">
				<div class="team-img">
					<div :key="a.userId" v-for="a in chatingAssignee.members">
						<div class="agent-image">
							<ImageContainer :title="a.firstName" :imgSrc="a.imageURL || ''" height="50" width="50" :initial='initial(a)'/>
						</div>
					</div>
				</div>
				<div class="team-name">
					{{ chatingAssignee.teamName }}
				</div>
			</div>
			<div class="rp-agent-header animated fadeInRight" v-else-if="chatingAssignee.type === 'team'">
				<template v-for="(a,index) in chatingAssignee.members">
					<div class="agent-img"  :key="a.userId" v-if="index<3">
					<div class="agent-image"  >
						<ImageContainer :title="a.firstName" :imgSrc="a.imageURL || ''" height="32" width="32" :initial='initial(a)'/>
						<!-- <div v-if="isAgentOnline(agent)" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info"></div> -->
					</div>
				</div>
				</template>
				
				<div>
					{{ chatingAssignee.teamName }}
				</div>
			</div>
			<!--not needed below div for now--->
			<div class="rp-agent-header-full animated fadeInRight" v-if="chatingAssignee.type === 'assignee' && openHeader === true">
				<div class="agent-details-profile">
					<div class="agent-img" >
						<div class="agent-image">
							<ImageContainer :imgSrc="chatingAssignee.imageURL || ''" height="50" width="50" :initial='initial(chatingAssignee)'/>
						</div>
					</div>
					<div>
						{{ chatingAssignee.firstName }}
					</div>
				</div>
			</div>
			<div class="rp-agent-header animated fadeInRight" v-else-if="chatingAssignee.type === 'assignee'">
				<div class="agent-img" >
					<div class="agent-image">
						<ImageContainer :title="chatingAssignee.firstName" :imgSrc="chatingAssignee.imageURL || ''" height="40" width="40" :initial='initial(chatingAssignee)'/>
						<!-- <div v-if="isAgentOnline(chatingAssignee)" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info status-for-assignee"></div> -->
					</div>
				</div>
				<div class="intro-about-company">
					<div class="company-name">{{ chatingAssignee.firstName }}</div>
					<div class="company-welcome-text animated fast fadeInRight" >
						{{ getIntro }}
						<!-- {{ isAgentOnline(chatingAssignee) ? 'Online' : nextAvailableBusinessHours }} -->
					</div>
				</div>
			</div>
			<CloseChatUI
				:closingChat="closingChat"
				v-if="canDisplayCloseChat"
				@closeChat="closeChat"
			/>
			</div>
		</template>
    </div>
</template>
<script>
import BackButton from './BackButton'
import { mapActions, mapGetters } from 'vuex';
import ImageContainer from './ImageContainer'
import CloseChatUI from '../shared/CloseChatUI.vue'
export default {

	props: {
		activeColor: {
			type: String,
			required: true
		},
		brandName: {
			type: String,
			default: ''
		},

		replyTimeLabel: {
			type: String,
			required: true
		},

		intro: {
			type: String,
			required: true
		},
		messengerStyle: {
			type: Object,
			required:true
		},
		openHeader: {
			type:Boolean,
			required: true
		},
		nextAvailableBusinessHours: {
			type: String,
			required: true,
		},
		teamToRespond: {
			type: String,
			required: true,
		},
		notificationCount: {
			type: Number,
			required: false
		},
		headerForScenarios: {
			type: Boolean,
			default: false
		},
		canDisplayCloseChat: {
			type: Boolean,
			default: false,
		},
		closingChat: {
			type: Boolean,
			default: false,
		}

	},

	components: {
		BackButton,
		ImageContainer,
		CloseChatUI
	},
	data() {
		return {
			errorImage: []
		}
	},
	methods: {
		closeChat() {
			this.$emit('closeChat', {})
		},
		initial(agent){
			if(agent.firstName && agent.lastName)
			return agent.firstName[0] + " " + agent.lastName[0] || ''
		},
		errorInImg(agent){
			this.errorImage.push(agent.id)
			//console.log("error in loading iames")
		},
		displayInitial(agent){
			if(this.errorImage.indexOf(agent.id) === -1){
				return true;
			}
			return false;
		},
		isAgentOnline({ id }) {
			return this.activeAgentList.findIndex((agent)=> agent.operatorId === id) >= 0;
		},
	},
	computed: {
		...mapGetters({
			agentList: 'agentList',
			selectedConversationDetails: 'selectedConversation',
			getUserAndTeam: 'getUserAndTeam',
			activeAgentList: 'activeAgentList',
			getMembersOfATeam: 'getMembersOfATeam',
		}),

		conversationHeaderStyle(){
			const { messengerStyle, openHeader } = this
			let style = {
				...messengerStyle
			}
			if(openHeader){
				style['height'] = '205px'
			}
			else {
				style['height'] = '75px'
			}

			return style
		},
		
		chatingAssignee() {
			if(this.headerForScenarios) {
				return {};
			}
			const { getUserAndTeam, selectedConversationDetails } = this
			const assigneeId = selectedConversationDetails.assignee
			let selectedAssignee = getUserAndTeam.filter(ass => {
				if(ass.id === assigneeId){
					return true
				}
			})
			return selectedAssignee[0] || {}
		},

		selectedAgent() {
			let teamMembers = []
			const agentList = this.getMembersOfATeam(this.teamToRespond)
			Object.keys(agentList).map(key => {
				const agent = agentList[key];
				//checking for invitation acceptance
				//Name first name and last name means 
				//invitation not yet accepted
				//so skip them 
				if(agent.firstName && agent.lastName && agent.isChatAccess !== false)
					teamMembers.push(agent)
			})
			//prioritize the users who has images by sorting the agent list
			teamMembers.sort((a,b) => { if(a.imageURL) return -1; return 1 } )
			return (teamMembers || []).slice(0,3)
		},
		getIntro() {
			const { nextAvailableBusinessHours, replyTimeLabel } = this;

			return nextAvailableBusinessHours=='Away' ? replyTimeLabel : nextAvailableBusinessHours;
		}
	}
}

</script>

<style lang="scss">

.rp-agent-header-full {
	margin-left: 10px;
	display: flex;
	flex-direction: column;
	.agent-details-profile{
		display:flex;
		flex-direction: row;
		align-items: center;
		height:100px;
	}
}
.rp-helpdesk-conversation-list-item-online-status-in-agents-info {
    display: flex;
    height: 10px;
    width: 10px;
    background: #70d526;
    border-radius: 10px;
    position: absolute;
}
.status-for-assignee {
    bottom: 10px;
    left: 30px;
}
.status-for-team {
	top: -5px !important;
	right: 8px !important;
	@include for-size(desktop-up){
		right: 0px !important;
		top: -8px !important;
	}
}

.rp-messenger-header__conversation {
	padding: 0.8rem 1rem 0.8rem 0.8rem;
	display: flex;
	transition: height 360ms ease-out 0s;
	.rp-conversation-header-warpper{
		display: flex;
		justify-content: space-between;
		width: 100%
	}
	@media only screen 
		and (min-device-width: 320px) 
		and (max-device-width: 480px) {
		.rp-conversation-header-warpper{
			width: calc(100%-150px)
		}
	}
	.count-badge {
		.el-badge__content{
			background-color: red !important;
			border: 1px solid #c78e8e;
			top: 11px;
    		right: 32px;
		}
	}
	.rp-agent-header-full-team{
		display: flex;
    	flex-direction: column;
		width: calc(100% - 60px);
		.team-img{
			display:flex;
			flex-direction: row;
			padding:20px;
		}
		.team-name{
			padding-left:20px;
			text-transform: capitalize;
		}
		.agent-img{
			display: flex;
			flex-direction: row;
		}
	}
	.intro-about-company {
			margin-left: 0.7rem;
			max-width: 200px;
			margin-bottom: 5px;
			@media only screen 
			and (min-device-width: 320px) 
			and (max-device-width: 480px){
				max-width: 105px;
			}
		}
	.rp-conversation-header-agent{
		display:flex;
		justify-content: center;
		align-items:center;
		padding-left: 10px;
		// margin-top: 7px;
		.company-name{
			font-size: 14px;
			@include for-size(desktop-up){
				font-size: 16px;
			}
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-weight: 500
		}
		.company-welcome-text{
			font-size: 11px;
			font-weight: 500;
			@include for-size(desktop-up){
				font-size: 14px;
			}
			opacity: .7;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: rgba(255,255,255,0.7);
		}
		.agent{
			margin-right:-10px;
			@include for-size(desktop-up){
				margin-right: 10px;
			}
			width: 32px;
    		height: 32px;
    		border-radius: 50%;
			//background: #ffff;
			display: flex;
			align-items: center;
    		justify-content: center;
			position: relative;
			&:last-child {
				margin-left:0;
			}
		}
	}
	.rp-agent-header{
		display: flex;
		align-items: center;
		font-weight: 500;
		.company-welcome-text{
			font-size: 11px;
			@include for-size(desktop-up){
				font-size: 14px;
			}
			opacity: .7;
			font-weight: 400;
			color: rgba(255,255,255,0.7);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.company-name{
			font-size: 14px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-weight: 500
		}
	}
	.agent-img{
		//margin-right:10px;
		margin-left:-20px;
		&:first-child {
			margin-left:0px;
		}

	}

	.company-details {
		padding-top: 15px;
		padding-left: 1rem;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.company-name {
			font-weight: 400;
		}

		.company-welcome-text {
			margin-top: 2px;
			font-weight: 200;
			font-size: 13px;
			@include for-size(desktop-up){
				font-size: 16px;
			}
			opacity: .7;
			color: rgba(255,255,255,0.7);
			font-weight: 400;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.all-agents {
			display: flex;
			margin: 20px 0;
			.agent {
				$size: 50px;
				
				width: 70px;
				margin-right: 8px;
				text-align: center;

				.agent-image {
					width: 50px;
					height: 50px;
					margin: auto;
					border-radius:25px;
					background: #fafafa;
					display: flex;
    				align-items: center;
    				justify-content: center;
					img {
						border-radius: 50%;
						width: $size;
						height: $size;
					}
				}

				.agent-first-name {
					font-size: 12px;
					opacity: .7;
				}
			}
		}

		.team-usual-reply-time {
			font-size: 12px;
		}
	}
}

</style>